'use client';
import React from 'react';
import { useRouter } from 'next/navigation';
import { PROPERTY_CATEGORIES } from '../data/deals';

const CAT_TO_HOTEL: Record<string, string> = {
  'cat-hotel': 'prop-1',
  'cat-riad': 'prop-3',
  'cat-resort': 'prop-2',
  'cat-desert': 'prop-4',
  'cat-villa': 'prop-4',
  'cat-apart': 'prop-1',
};

const CAT_TO_NAME: Record<string, string> = {
  'cat-hotel': 'Hotels',
  'cat-riad': 'Riads',
  'cat-resort': 'Resorts',
  'cat-desert': 'Desert Camps',
  'cat-villa': 'Villas',
  'cat-apart': 'Apartments',
};

export default function PropertyCategories() {
  const router = useRouter();

  const handleCatClick = (catId: string) => {
    const type = CAT_TO_NAME[catId] ?? '';
    router.push(`/hotels?type=${encodeURIComponent(type)}`);
  };

  return (
    <section className="py-10 sm:py-14" style={{ background: '#FBF8F3' }}>
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
        {/* Header */}
        <div className="mb-5 sm:mb-8">
          <p className="text-xs font-display font-600 text-primary-500 uppercase tracking-widest mb-1" style={{ fontWeight: 600 }}>
            Browse by type
          </p>
          <h2 className="font-display text-2xl sm:text-3xl font-800 text-gray-900" style={{ fontWeight: 800 }}>
            What kind of stay?
          </h2>
        </div>

        {/* Mobile: horizontal scroll row, Desktop: grid */}
        <div className="flex gap-3 overflow-x-auto pb-2 sm:pb-0 sm:grid sm:grid-cols-3 lg:grid-cols-6 sm:gap-3 lg:gap-4 scrollbar-hide -mx-4 px-4 sm:mx-0 sm:px-0">
          {PROPERTY_CATEGORIES?.map((cat) => (
            <div
              key={cat?.id}
              onClick={() => handleCatClick(cat?.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleCatClick(cat?.id)}
              aria-label={`Browse ${cat?.name} — ${cat?.count} places`}
              className="group relative rounded-2xl overflow-hidden cursor-pointer card-shadow hover:card-shadow-lg transition-all duration-300 flex-shrink-0 w-28 sm:w-auto active:scale-[0.97]"
              style={{ aspectRatio: '3/4' }}
            >
              <img
                src={cat?.image}
                alt={cat?.alt}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute inset-0 bg-primary-500/0 group-hover:bg-primary-500/10 transition-all duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-2 sm:p-3">
                <div className="text-base sm:text-lg mb-0.5">{cat?.icon}</div>
                <h3 className="font-display font-700 text-white text-xs sm:text-sm leading-tight" style={{ fontWeight: 700 }}>
                  {cat?.name}
                </h3>
                <p className="text-white/70 text-xs font-body">{cat?.count} places</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
